import Config from "../../app/config/Config"

export default class BaseSaveModel {
    /**
     * 
     * @param {Config} config 
     */
    constructor(config) {
        this._config = config;

        this._saveGame = null;
        this._lastInteractionEventIndex = 0;
    }

    setSaveGame(obj) {
        if (!obj) {
            console.log("BaseSaveModel.setSaveGame, no savegame");
            return;
        }

        const currentVersion = this._config.getValue(Config.VERSION);
        if (currentVersion !== obj.version) {
            console.warn(`BaseSaveModel.setSaveGame: Savegame version (${obj.version}) does not correspond to current version (${currentVersion}). Ignoring savegame.`);
            return;
        }

        this._saveGame = obj;
        this._lastInteractionEventIndex = this._saveGame.lastInteractionEventIndex || 0;
    }

    /**
     * @returns {Object} Generic object containing save state.
    */
    getSaveGame() {
        return this._saveGame;
    }

    createSaveGame() {
        const baseSaveGame = {
            version: this._config.getValue(Config.VERSION),
            lastInteractionEventIndex: this._lastInteractionEventIndex,
        };
        const minigameSaveGame = this._createMinigameSaveGame();
        return Object.assign(baseSaveGame, minigameSaveGame);
    }

    get lastInteractionEventIndex() {
        return this._lastInteractionEventIndex;
    }

    set lastInteractionEventIndex(value) {
        this._lastInteractionEventIndex = value;
    }

    _createMinigameSaveGame() {
        throw new Error("BaseSaveModel._createMinigameSpecificSaveGame: method not implemented");
    }
};
